import { render, staticRenderFns } from "./side-by-side-row-lvl2-warning.vue?vue&type=template&id=1d59318d"
import script from "./side-by-side-row-lvl2-warning.vue?vue&type=script&lang=js"
export * from "./side-by-side-row-lvl2-warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports